export const SET_IP_COUNTRY_CODE = 'SET_IP_COUNTRY_CODE';

export const setIpCountryCodeAction = (data) => {
  return {
    type: SET_IP_COUNTRY_CODE,
    data
  };
};
